<div class="content">
  <app-floating-ui />
  <div class="map">
    <app-map-renderer></app-map-renderer>
  </div>
</div>
